import React from "react";
import styled from "styled-components";

const StyledComponent = styled.div`
  border-bottom: 1px solid #cccccc;
  padding: 10px 0;
  .sub-title-bar {
    border-right: 2px solid #cccccc;
    padding: 0 15px;
    margin: 5px 0;
  }
  .list {
    padding: 0 25px;
    .item {
      border-right: 2px solid #333333;
      padding: 10px;
      margin: 10px 0;
      transition: 0.5s background ease;
      cursor: pointer;
      &:hover {
        background-color: #cccccc;
      }
      .verify-text {
        font-size: 0.7rem;
        color: #333333;
        margin: 0 5px;
      }
      &.verified {
        border-right-color: #35c974;
      }
      &.not-verified {
        border-right-color: hsla(357, 70%, 47%, 0.7);
      }
    }
  }
`;

function Container(props) {
  const { children } = props;

  return <StyledComponent>{children}</StyledComponent>;
}

export default React.memo(Container);
